import { api } from './client.js';

const root = '/admin/notifications';

export const notificationsApi = {
  getConfig: () => api.get(`${root}/config`),
  updateConfig: (body) => api.put(`${root}/config`, body),
  test: (body) => api.post(`${root}/test`, body),
  listEvents: () => api.get(`${root}/events`),
  updateRule: (eventKey, body) => api.put(`${root}/rules/${encodeURIComponent(eventKey)}`, body),
  listTemplates: (params) => api.get(`${root}/templates`, { query: params }),
  createTemplate: (body) => api.post(`${root}/templates`, body),
  updateTemplate: (id, body) => api.patch(`${root}/templates/${id}`, body),
  removeTemplate: (id) => api.delete(`${root}/templates/${id}`),
  previewTemplate: (body) => api.post(`${root}/templates/preview`, body),
  listLogs: (params) => api.get(`${root}/logs`, { query: params })
};
